export default __webpack_public_path__ + "static/media/eSourcing-instruction.c9911559.gif";